const React = require('react');
const AdminFeeTable = require('../../../../../../../dumb/AdminHelpers/AdminFeeTable');
const withState = require('../../../../../../../../utils/withState');
const {
  apiAdminMerchantCustomerFeesGet,
  apiAdminMerchantCustomerFeesUpdate,
  apiAdminMerchantCustomerFeesReset
} = require("../../../../../../../../api/admin/retailers");

module.exports = withState((setState, self, onMount) => {
  self.state = {
    ...self.state,
    loading: true
  };

  const onSubmit = ({payload, confirmBearer}) => (
    apiAdminMerchantCustomerFeesUpdate({
      merchant_id: self.props.userId,
      payload,
      confirmBearer
    })
  );

  const onResult = () => {
    setState({isGlobal: false});
  }

  const onGlobalClick = (confirmBearer) => {
    setState({loading: true});

    const merchant_id = self.props.userId;
    return apiAdminMerchantCustomerFeesReset({merchant_id, confirmBearer})
        .then(() => apiAdminMerchantCustomerFeesGet({merchant_id}))
        .then((res) => setState({list: res.list || [], isGlobal: true}))
        .catch(() => {})
        .finally(() => setState({loading: false}))
  }

  onMount(() => {
    const merchant_id = self.props.userId;

    apiAdminMerchantCustomerFeesGet({merchant_id})
      .then((res = {}) => {

        const list = res.list || [];
        list.every((el) => {
          return el.merchant_id === '00000000-0000-0000-0000-000000000000'
        })
        return (
          setState({
            list,
            isGlobal: list.every((el) => el.merchant_id === '00000000-0000-0000-0000-000000000000'),
            loading: false
          })
        )
      });
  });

  return ({loading, list, isGlobal}) => {
    return loading
      ? (
        <span />
      ) : (
        <div className="mt53">
          <AdminFeeTable
            items={list}
            maxHeight={window.innerHeight - 575}
            onSubmit={onSubmit}
            onResult={onResult}
            onGlobalClick={onGlobalClick}
            disabledGlobal={isGlobal}
          />
        </div>
      )
  }
});
